

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface StorageShelfParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface StorageShelf { 
    id?: any;
    tenantId: any;
    branchId: any;  
    name:string;
   
    
    parameters?: StorageShelfParameter[];
    links?: any;
}


export abstract class StorageShelfData {
    
    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<StorageShelf[]>;
    abstract create(url: string, data: StorageShelf): Observable<StorageShelf[]>;
    abstract update(url: string, data: StorageShelf): Observable<StorageShelf>;
    abstract delete(url: string): Observable<any>; 

    //uploadData    
    abstract postData(url: string, data: any[]): Observable<any>;
}
